module.exports = __webpack_public_path__ + "img/user.dc808962.svg";